import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { getSessionItem, removeSessionItem } from "@/utils/safeStorage";

const CHECKOUT_SUCCESS_KEY = "checkoutSuccessPending";

export function CheckoutStatusToastGate() {
  const location = useLocation();

  useEffect(() => {
    const pending = getSessionItem(CHECKOUT_SUCCESS_KEY);
    if (pending !== "1") return;

    removeSessionItem(CHECKOUT_SUCCESS_KEY);
    toast.success("Your plan is active. Welcome to Coach Veera.");
  }, [location.pathname, location.search]);

  return null;
}
